import { Classes, Dialog } from "@blueprintjs/core";
import styles from "modules/spending/workload-plan/components/PlanHelpDialog.module.scss";
import React from "react";

interface ProjectPlanHelpDialogProps {
    isOpen: boolean;
    /** Есть что править — показываем и разделы про правку */
    canEdit: boolean;
    onClose: () => void;
}

interface HelpRow {
    gesture: string;
    action: string;
}

const CONTENTS: HelpRow[] = [
    { gesture: "Полосы", action: "свои силы — из Табеля План, подрядчики — из состава затрат" },
    { gesture: "Красная штриховка", action: "конфликт; двойной клик — перейти ко второй стороне" },
];

const VIEW: HelpRow[] = [
    { gesture: "Правый клик по работе", action: "связи работы" },
    { gesture: "Двойной клик по вехе", action: "открыть веху" },
    { gesture: "Esc", action: "снять выделение и подсветку" },
];

const MOVING: HelpRow[] = [
    { gesture: "Тянуть полосу", action: "сдвинуть работу, раздел или проект целиком" },
    { gesture: "Тянуть край", action: "изменить начало, окончание или срок" },
    { gesture: "Правый клик по проекту", action: "сдвинуть всё с выбранной даты" },
    { gesture: "Двойной клик по проекту", action: "добавить веху" },
    { gesture: "Точка у края полосы", action: "протянуть связь к другой полосе" },
];

const DRAFT: HelpRow[] = [
    { gesture: "Сохранить", action: "правки копятся в черновике, другие их не видят" },
    { gesture: "Применить черновик", action: "перенести правки в план" },
    { gesture: "Согласования", action: "сдвиги в чужих проектах ждут решения ГИПа" },
];

const Section = ({ title, rows }: { title: string; rows: HelpRow[] }) => (
    <div className={styles.section}>
        <div className={styles.title}>{title}</div>

        {rows.map((row) => (
            <div key={row.gesture} className={styles.row}>
                <div className={styles.gesture}>{row.gesture}</div>
                <div className={styles.action}>{row.action}</div>
            </div>
        ))}
    </div>
);

export const ProjectPlanHelpDialog: React.FC<ProjectPlanHelpDialogProps> = ({ isOpen, canEdit, onClose }) => (
    <Dialog
        title="Инструкция по работе"
        isOpen={isOpen}
        onClose={onClose}
        backdropClassName="standard"
        className={`${styles.dialog} figma-dialog`}
    >
        <div className={Classes.DIALOG_BODY}>
            <Section title="Что на графике" rows={CONTENTS} />
            <Section title="Просмотр" rows={VIEW} />

            {/* правка — тому, кто только смотрит, она ни к чему */}
            {canEdit && (
                <>
                    <Section title="Правка" rows={MOVING} />
                    <Section title="Черновик" rows={DRAFT} />
                </>
            )}
        </div>
    </Dialog>
);
